<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>

                <b-col cols="12" md="10">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">修改密碼</span>
                        </template>
                        <b-form>
                            <b-form-group label-for="new-password">
                                <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>新密碼</template>
                                <b-form-input
                                    id="new-password"
                                    v-model="PasswordItem.Password"
                                    type="password"
                                    placeholder="新密碼"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label-for="confirm-password">
                                <template #label><b-badge variant="danger" class="mt-1 mr-2">必填</b-badge>確認新密碼</template>
                                <b-form-input
                                    id="confirm-password"
                                    v-model="PasswordItem.PasswordConfirm"
                                    type="password"
                                    placeholder="確認新密碼"
                                ></b-form-input>
                            </b-form-group>

                            <b-button variant="primary" @click.prevent="form2Save()">儲存</b-button>
                        </b-form>
                    </b-card>

                    <b-card v-if="featureFlags.enableLine" class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">LINE 綁定</span>
                        </template>
                        <div class="line-binding-card">
                            <b-alert v-if="lineBindingBanner.message" :show="true" :variant="lineBindingBanner.variant" class="mb-3">
                                {{ lineBindingBanner.message }}
                            </b-alert>

                            <div class="line-binding-summary mb-3">
                                <div class="line-binding-summary-item">
                                    <div class="line-binding-label">綁定狀態</div>
                                    <div class="line-binding-value">
                                        <b-badge :variant="lineBindingBadgeVariant">{{ lineBindingDisplayStatus }}</b-badge>
                                    </div>
                                </div>
                                <div class="line-binding-summary-item">
                                    <div class="line-binding-label">LINE 顯示名稱</div>
                                    <div class="line-binding-value">{{ lineBindingDisplayName }}</div>
                                </div>
                                <div class="line-binding-summary-item">
                                    <div class="line-binding-label">綁定時間</div>
                                    <div class="line-binding-value">{{ lineBindingDisplayTime }}</div>
                                </div>
                            </div>

                            <b-alert v-if="lineBindingHint" show variant="secondary" class="mb-3">
                                {{ lineBindingHint }}
                            </b-alert>

                            <div class="d-flex flex-wrap align-items-center">
                                <b-button
                                    v-if="!isLineBound"
                                    variant="success"
                                    class="mr-2 mb-2"
                                    :disabled="lineBindingActionLoading"
                                    @click.prevent="startLineBinding()"
                                >
                                    {{ lineBindingActionLoading ? '處理中...' : '綁定 LINE' }}
                                </b-button>
                                <b-button
                                    v-else
                                    variant="outline-danger"
                                    class="mr-2 mb-2"
                                    :disabled="lineUnbindingLoading"
                                    @click.prevent="unbindLine()"
                                >
                                    {{ lineUnbindingLoading ? '解除中...' : '解除綁定' }}
                                </b-button>
                                <b-button
                                    variant="outline-secondary"
                                    class="mb-2"
                                    :disabled="lineBindingLoading"
                                    @click.prevent="loadLineBindingStatus({ silent: false })"
                                >
                                    {{ lineBindingLoading ? '更新中...' : '重新整理狀態' }}
                                </b-button>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import moment from 'moment';
import nacUser from '@/components/nacUser.vue';
import {
    apiGetMember,
    apiResetPassword,
    apiCreateMemberLineBinding,
    apiDeleteMemberLineBinding,
    apiGetMemberLineBinding,
    featureFlags,
} from '@/api/API.js';
import {
    extractLineBindingLiffUrl,
    extractLineBindingNonce,
    saveLineBindingRequest,
} from '@/utils/lineBinding';

const lineStatusTextMap = {
    unbound: '尚未綁定 LINE',
    linked: '已綁定 LINE',
    pending_line_identity: '請先完成 LINE 身分確認',
    failed: 'LINE 綁定未完成，請重新操作',
    identity_verification_not_configured: 'LINE 綁定功能尚未完成設定',
    identity_verification_not_supported: '目前尚未支援此 LINE 驗證方式',
};

export default {
    name: 'account-security',
    components: {
        nacUser,
    },
    data() {
        return {
            title: '帳號安全',
            memberId: '',
            PasswordItem: {
                Password: '',
                PasswordConfirm: '',
            },
            lineBindingLoading: false,
            lineBindingActionLoading: false,
            lineUnbindingLoading: false,
            lineBinding: {
                isBound: false,
                status: 'unbound',
                boundAt: '',
                displayName: '',
                message: '',
                nextAction: '',
                lineIdentityUrl: '',
                liffUrl: '',
                lineLoginUrl: '',
                raw: null,
            },
            lineBindingBanner: {
                variant: 'info',
                message: '',
            },
            lineBindingWindowOpened: false,
            lineBindingPollingTimer: null,
            lineBindingPollingStartedAt: 0,
            featureFlags,
        };
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('請先登入會員');
            this._go('/');
            return;
        }
        this.Init();
    },
    beforeDestroy() {
        this.stopLineBindingPolling();
    },
    computed: {
        isLineBound() {
            return this.lineBinding.isBound || this.lineBinding.status === 'linked';
        },
        lineBindingDisplayStatus() {
            return this.getLineStatusText(this.lineBinding.status);
        },
        lineBindingDisplayName() {
            return this.lineBinding.displayName || '尚無資料';
        },
        lineBindingDisplayTime() {
            if (!this.lineBinding.boundAt) {
                return '尚無資料';
            }
            const date = moment(this.lineBinding.boundAt);
            return date.isValid() ? date.format('YYYY-MM-DD HH:mm') : this.lineBinding.boundAt;
        },
        lineBindingBadgeVariant() {
            switch (this.lineBinding.status) {
                case 'linked':
                    return 'success';
                case 'pending_line_identity':
                    return 'warning';
                case 'failed':
                case 'identity_verification_not_configured':
                case 'identity_verification_not_supported':
                    return 'danger';
                default:
                    return 'secondary';
            }
        },
        lineBindingHint() {
            if (this.lineBindingWindowOpened && !this.isLineBound) {
                return '請在新開視窗完成 LINE 綁定，完成後關閉該視窗並回此頁重新整理狀態。';
            }
            if (this.lineBinding.message) {
                return this.lineBinding.message;
            }
            if (this.lineBinding.status === 'pending_line_identity') {
                return '系統已建立綁定請求，接下來會導向 LINE LIFF 頁完成身分確認。';
            }
            if (this.lineBinding.status === 'failed') {
                return '前一次 LINE 綁定未完成，可重新發起綁定流程。';
            }
            return '';
        },
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        Init() {
            apiGetMember()
                .then((res) => {
                    this.memberId = res.data?.User?.Id || '';
                })
                .catch(() => {
                    alert('請先登入會員');
                    this._go('/');
                });
            if (this.featureFlags.enableLine) {
                this.loadLineBindingStatus({ silent: true });
            }
        },
        form2Save() {
            this.PasswordItem.Id = this.memberId;
            apiResetPassword(this.PasswordItem)
                .then(() => {
                    alert('密碼已更新');
                    this.PasswordItem.Password = '';
                    this.PasswordItem.PasswordConfirm = '';
                })
                .catch((err) => {
                    void err;
                });
        },
        getLineStatusText(status) {
            return lineStatusTextMap[status] || 'LINE 綁定狀態更新中';
        },
        normalizeLineBindingPayload(payload) {
            const data = payload || {};
            const isBoundValue = data.isBound ?? data.IsBound ?? data.isLinked ?? data.IsLinked ?? data.bound ?? data.Bound ?? data.linked ?? data.Linked;
            const status = data.status || data.Status || (isBoundValue ? 'linked' : 'unbound');
            return {
                isBound: Boolean(
                    isBoundValue ??
                        status === 'linked',
                ),
                status,
                boundAt: data.boundAt || data.BoundAt || data.bindingTime || data.BindingTime || data.linkedAt || data.LinkedAt || '',
                displayName:
                    data.displayName || data.DisplayName || data.lineDisplayName || data.LineDisplayName || data.name || data.Name || data.lineName || data.LineName || '',
                message: data.message || data.Message || '',
                nextAction: data.nextAction || data.NextAction || '',
                lineIdentityUrl: data.lineIdentityUrl || data.LineIdentityUrl || '',
                liffUrl: data.liffUrl || data.LiffUrl || '',
                lineLoginUrl: data.lineLoginUrl || data.LineLoginUrl || '',
                raw: data,
            };
        },
        setLineBindingBanner(message = '', variant = 'info') {
            this.lineBindingBanner = {
                message,
                variant,
            };
        },
        startLineBindingPolling() {
            if (this.lineBindingPollingTimer) {
                return;
            }
            this.lineBindingPollingStartedAt = Date.now();
            this.lineBindingPollingTimer = window.setInterval(async () => {
                const isTimedOut = Date.now() - this.lineBindingPollingStartedAt > 2 * 60 * 1000;
                if (isTimedOut) {
                    this.stopLineBindingPolling();
                    return;
                }
                await this.loadLineBindingStatus({ silent: true });
            }, 5000);
        },
        stopLineBindingPolling() {
            if (this.lineBindingPollingTimer) {
                window.clearInterval(this.lineBindingPollingTimer);
                this.lineBindingPollingTimer = null;
            }
            this.lineBindingPollingStartedAt = 0;
        },
        async loadLineBindingStatus({ silent = false } = {}) {
            if (!this.featureFlags.enableLine) {
                return;
            }
            this.lineBindingLoading = true;
            if (!silent) {
                this.setLineBindingBanner('');
            }
            try {
                const res = await apiGetMemberLineBinding();
                this.lineBinding = this.normalizeLineBindingPayload(res.data);
                if (this.lineBinding.status === 'linked') {
                    this.lineBindingWindowOpened = false;
                    this.stopLineBindingPolling();
                }
                if (!silent && this.lineBinding.message) {
                    this.setLineBindingBanner(this.lineBinding.message, 'info');
                }
            } catch (err) {
                void err;
                if (!silent) {
                    this.setLineBindingBanner('無法取得 LINE 綁定狀態，請稍後再試。', 'danger');
                }
            } finally {
                this.lineBindingLoading = false;
            }
        },
        async startLineBinding() {
            if (!this.featureFlags.enableLine) {
                return;
            }
            this.lineBindingActionLoading = true;
            this.setLineBindingBanner('');
            try {
                const res = await apiCreateMemberLineBinding();
                const result = this.normalizeLineBindingPayload(res.data);
                const nonce = extractLineBindingNonce(res.data);
                const liffUrl = extractLineBindingLiffUrl(res.data);
                this.lineBinding = result;
                if (nonce) {
                    saveLineBindingRequest({
                        nonce,
                        createdAt: new Date().toISOString(),
                    });
                }
                if (result.nextAction === 'complete_line_identity') {
                    if (liffUrl) {
                        window.open(liffUrl, '_blank', 'noopener,noreferrer');
                        this.lineBindingWindowOpened = true;
                        this.startLineBindingPolling();
                        this.setLineBindingBanner(
                            '已在新視窗開啟 LINE 綁定流程，完成後請回此頁重新整理狀態。',
                            'info',
                        );
                        return;
                    }
                    this.setLineBindingBanner('尚未設定 LINE 身分確認入口', 'warning');
                    return;
                }
                this.setLineBindingBanner(
                    result.message || this.getLineStatusText(result.status),
                    result.status === 'failed' ? 'danger' : 'info',
                );
                await this.loadLineBindingStatus({ silent: true });
            } catch (err) {
                void err;
                this.setLineBindingBanner('LINE 綁定流程啟動失敗，請稍後再試。', 'danger');
            } finally {
                this.lineBindingActionLoading = false;
            }
        },
        async unbindLine() {
            if (!this.featureFlags.enableLine) {
                return;
            }
            this.lineUnbindingLoading = true;
            this.setLineBindingBanner('');
            this.lineBindingWindowOpened = false;
            this.stopLineBindingPolling();
            try {
                await apiDeleteMemberLineBinding();
                this.setLineBindingBanner('LINE 綁定已解除。', 'success');
                await this.loadLineBindingStatus({ silent: true });
            } catch (err) {
                void err;
                this.setLineBindingBanner('解除 LINE 綁定失敗，請稍後再試。', 'danger');
            } finally {
                this.lineUnbindingLoading = false;
            }
        },
    },
};
</script>

<style scoped>
.line-binding-card {
    word-break: break-word;
}

.line-binding-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
}

.line-binding-summary-item {
    padding: 12px;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background: #fff;
}

.line-binding-label {
    margin-bottom: 6px;
    color: #6c757d;
    font-size: 0.875rem;
}

.line-binding-value {
    color: #212529;
    font-size: 1rem;
}
</style>
